@if (control) {
  @if (!disabled) {
    <mat-drawer-container autosize>
      <mat-drawer mode="side" [opened]="selectedMarkers !== null && selectedMarkers.length > 0">
        @if (selectedMarkers !== null && selectedMarkers.length > 0) {
          <div class="inner">
            <ng-container [ngComponentOutlet]="markerDisplayComponent" [ngComponentOutletInputs]="{ data: selectedMarkers }" />
            <button class="close-button" (click)="closeMarker()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      </mat-drawer>

      <div class="map-container" #container></div>
    </mat-drawer-container>
    <div class="marker-overlay" [class.active]="selectedMarkers !== null"></div>
  } @else {
    <span>map disabled works!</span>
  }
} @else {
  <span>map loading works!</span>
}
